// @flow

import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';

import ButtonToggle from 'app/components/commons/ButtonToggle';
import HorseSwapRules from './HorseSwapRules';
import PlayerSwapRules from './PlayerSwapRules';

type Props = {
  siteName: string
};

const Wrapper = styled.div(({ theme }) => ({
  marginTop: 30,
  '& a': {
    color: theme.color.info
  }
}));

const SwapRules: React.FC<Props> = ({ siteName }: Props) => {
  const [entityName, setEntityName] = useState('player');

  const handleChangeEntityName = (value: boolean) => {
    setEntityName(value);
  };

  return (
    <Wrapper className="content">
      <ButtonToggle
        onChange={handleChangeEntityName}
        options={[
          {
            label: 'Player',
            value: 'player'
          },
          {
            label: 'Racing',
            value: 'racing'
          }
        ]}
        value={entityName}
        size="small"
      />
      {entityName === 'player' && <PlayerSwapRules siteName={siteName} />}
      {entityName === 'racing' && <HorseSwapRules siteName={siteName} />}
    </Wrapper>
  );
};

const mapStateToProps = ({ settings }) => ({ siteName: settings.siteName });

export default connect(mapStateToProps)(SwapRules);
